import { render, staticRenderFns } from "./propostaRenovacaoCard.vue?vue&type=template&id=bbe38610&scoped=true"
import script from "./propostaRenovacaoCard.vue?vue&type=script&lang=js"
export * from "./propostaRenovacaoCard.vue?vue&type=script&lang=js"
import style0 from "./propostaRenovacaoCard.vue?vue&type=style&index=0&id=bbe38610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe38610",
  null
  
)

export default component.exports